
import { Component, Prop, Vue } from 'vue-property-decorator';
import ToggleableText from '@/components/form/ToggleableText.vue';
import { Sheet } from '@/model/Sheet';

@Component({
    components: {
        ToggleableText,
    },
})
export default class SheetHeader extends Vue {
    @Prop() readonly sheet?: Sheet | null;

    @Prop({ default: false, type: Boolean })
    readonly exportLoading!: boolean;
}
